import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../../redux/userSlice";
import Sidebar from "../../../components/Sidebar";
import FirstTimeUserHome from "./FirstTimeUserHome";
import ExistingUserNoQuizHome from "./ExistingUserNoQuizHome";
import ExistingUserNoCareerHome from "./ExistingUserNoCareerHome";
import ExistingUserNoPathwayHome from "./ExistingUserNoPathwayHome";
import ExistingUserWithPathwayHome from "./ExistingUserWithPathwayHome";

const TestHomePages = () => {
  const [selectedState, setSelectedState] = useState("first-time");
  const dispatch = useDispatch();
  const { targetJob } = useSelector((state) => state.user);
  const currentUserState = useSelector((state) => state.user);

  const userStates = [
    { value: "first-time", label: "1. First Time User", component: FirstTimeUserHome },
    { value: "existing-no-career", label: "2. Existing User - No Career", component: ExistingUserNoCareerHome },
    { value: "existing-no-quiz", label: "3. Existing User - No Quiz", component: ExistingUserNoQuizHome },
    { value: "existing-no-pathway", label: "5. Existing User - No Pathway", component: ExistingUserNoPathwayHome },
    { value: "existing-with-pathway", label: "6. Existing User - With Pathway", component: ExistingUserWithPathwayHome },
  ];

  const simulateUserState = (state) => {
    setSelectedState(state);
        
    switch (state) {
      case "first-time":
        dispatch(setUser({ 
          ...currentUserState,
          currentJob: null, 
          targetJob: null 
        }));
        break;
      case "existing-no-quiz":
        dispatch(setUser({ 
          ...currentUserState,
          currentJob: "Software Developer", 
          targetJob: null 
        }));
        break;
      case "existing-no-career":
        dispatch(setUser({ 
          ...currentUserState,
          currentJob: "Software Developer", 
          targetJob: null 
        }));
        break;
      case "existing-with-career":
        dispatch(setUser({ 
          ...currentUserState,
          currentJob: "Software Developer", 
          targetJob: "AI Product Manager" 
        }));
        break;
      case "existing-no-pathway":
        dispatch(setUser({ 
          ...currentUserState,
          currentJob: "Software Developer", 
          targetJob: "AI Product Manager" 
        }));
        break;
      case "existing-with-pathway":
        dispatch(setUser({ 
          ...currentUserState,
          currentJob: "Software Developer", 
          targetJob: "AI Product Manager" 
        }));
        break;
      default:
        break;
    }
  };

  const SelectedComponent = userStates.find(state => state.value === selectedState)?.component || FirstTimeUserHome;

  return (
    <Sidebar>
      <div className="min-h-screen bg-gray-50 p-6">
        {/* Test Controls */}
        <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 mb-6">
          <h2 className="text-xl font-bold text-gray-800 mb-4">🧪 Test Home Pages</h2>
          <p className="text-gray-600 mb-4">
            Select different user states to test the conditional home pages:
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {userStates.map((state) => (
              <button
                key={state.value}
                onClick={() => simulateUserState(state.value)}
                className={`p-3 rounded-lg border transition-colors ${
                  selectedState === state.value
                    ? "bg-purple-600 text-white border-purple-600"
                    : "bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-100"
                }`}
              >
                {state.label}
              </button>
            ))}
          </div>

          <div className="mt-4 p-3 bg-blue-50 rounded-lg">
            <p className="text-sm text-blue-800">
              <strong>Current State:</strong> {userStates.find(s => s.value === selectedState)?.label}
            </p>
            <p className="text-sm text-blue-600 mt-1">
              <strong>Target Job:</strong> {targetJob || "None"}
            </p>
            <p className="text-sm text-blue-600 mt-1">
              <strong>Current Job Description:</strong> {currentUserState.currentJobDescription ? "✅ Present" : "❌ Missing"}
            </p>
          </div>
        </div>

        {/* Render Selected Component */}
        <div className="border-2 border-dashed border-purple-300 rounded-lg">
          <SelectedComponent />
        </div>
      </div>
    </Sidebar>
  );
};

export default TestHomePages; 